<template>
  <section class="app-main">
    <router-view style="margin-top: 105px;"/>
    <div v-if="showQRCode" class="body-left"><img class="title-img" src="@/assets/image/beefapp_code.png" />
       <div class="code-cancel" @click="handleClickCancel()"></div>
    </div>
    <!--
    <div v-if="showQRCode2" class="body-left2">
      <div class="code-cancel2" @click="handleClickCancel2()">x</div>
      <p style="font-size: 15px; font-weight: bold; margin: 5px 0px 0px; color:#212529;">必孚公告</p>
      <p style="font-size: 13px; font-weight: 100;  margin: 0px 0px 10px; color:#212529;">条款更新</p>
      <p  class="hand" style="font-size: 12px; margin: 0px 0px 16px; color:#212529;" @click="handleTerms">《服务条款》</p>
      <p  class="hand" style="font-size: 12px; margin: 0px 0px 16px; color:#212529;" @click="handlePrivacyPolicy">《免责声明》</p>
    </div>
    -->
  </section>
</template>
<script>
export default {
  name: 'AppMain',
  props: {
    isShowQRCode: {
      type: Boolean,
      default: true
    },
    isShowQRCode2: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showQRCode: true,
      showQRCode2: true
    }
  },
  watch: {
    isShowQRCode (newVal) {
      this.showQRCode = false
    },
    isShowQRCode2 (newVal) {
      this.showQRCode2 = false
    }

  },
  methods: {
    handleClickCancel () {
      this.$emit('tab-cancel', false)
    },
    handleClickCancel2 () {
      this.showQRCode2 = false
    },
    handleTerms () {
      this.$router.push('/cn/Terms')
    },
    handlePrivacyPolicy () {
      this.$router.push('/cn/PrivacyPolicy')
    }
  }
}
</script>
<style scoped>
.app-main {
  /* min-height: calc(100vh - 492px); */
  overflow: hidden;
}
.body-left{
    color: #717375;
    display: block !important;
    position: fixed;
    text-align: center;
    top: 250px;
    z-index: 999;
    float: right;
    right: 5px;
}

.body-left2{
    display: block !important;
    position: fixed;
    text-align: center;
    top: 250px;
    z-index: 999;
    float: left;
    left: 5px;
    background-color: white;
    padding:0px;
    border-radius: 10px;
    border: 2px solid #a7a7a7;
    width: 115px;
}

.bodyvisual-left{
    color: #717375;
    display: block !important;
    position: fixed;
    text-align: center;
    top: 510px;
    z-index: 999;
    float: right;
    right: 5px;
}
.code-cancel{
  position: fixed;
  width: 23px;
  height: 23px;
  top:250px;
  /* left: 135px; */
  right: 5px;
  cursor: pointer;
}

.code-cancel2{
  position: relative;
  width: 23px;
  height: 23px;
  top: 0px;
  left: 85px;
  right: 5px;
  cursor: pointer;
}

.code-cancel1{
  position: fixed;
  width: 23px;
  height: 23px;
  top:510px;
  /* left: 135px; */
  right: 5px;
  cursor: pointer;
}

.title-img{
  width: 160px;
}
</style>
